var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-modal",
    {
      ref: "modalConfirm",
      attrs: {
        size: _vm.description ? "md" : "sm",
        "hide-header": "",
        "hide-footer": "",
        centered: "",
        "no-close-on-backdrop": "",
        "no-fade": "",
      },
    },
    [
      _c("validation-observer", {
        staticClass: "text-center",
        scopedSlots: _vm._u(
          [
            {
              key: "default",
              fn: function ({ valid }) {
                return [
                  _vm.useMessage
                    ? _c("p", [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.messageText) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.description
                    ? _c("p", { staticClass: "small" }, [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.description) +
                            "\n        "
                        ),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.showUpdateField
                    ? _c("v-input", {
                        staticClass: "mb-2",
                        attrs: {
                          type: "text",
                          rules: _vm.rules,
                          autocomplete: "off",
                        },
                        model: {
                          value: _vm.updateValue,
                          callback: function ($$v) {
                            _vm.updateValue = $$v
                          },
                          expression: "updateValue",
                        },
                      })
                    : _vm.showSelectField
                    ? _c("b-form-select", {
                        staticClass: "mb-2",
                        attrs: { options: _vm.selectOptions },
                        model: {
                          value: _vm.updateValue,
                          callback: function ($$v) {
                            _vm.updateValue = $$v
                          },
                          expression: "updateValue",
                        },
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    [
                      _vm._t("yes-button", function () {
                        return [
                          _c(
                            "b-button",
                            {
                              staticClass: "button button-success px-3 ml-auto",
                              attrs: { disabled: !valid },
                              on: { click: _vm.confirm },
                            },
                            [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(_vm.yesButtonLabel) +
                                  "\n                "
                              ),
                            ]
                          ),
                        ]
                      }),
                      _vm._v(" "),
                      _vm.useNoButton
                        ? _c(
                            "b-button",
                            {
                              staticClass: "button button-danger px-3 ml-3",
                              on: { click: _vm.reject },
                            },
                            [
                              _vm._v(
                                "\n                " +
                                  _vm._s(_vm.noButtonLabel) +
                                  "\n            "
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                ]
              },
            },
          ],
          null,
          true
        ),
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }